import * as React from "react";
import { FlightsLink } from "typings/microserviceModels/flights-flex-module";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { UitkSpacing } from "@egds/react-core/spacing";
import { UitkLayoutGrid, UitkLayoutGridItem } from "@egds/react-core/layout-grid";
import { FlightCard } from "components/flexComponents/Flights/components/FlightCard";

export interface FlightCardsProps {
  isMobile: boolean;
  isTablet: boolean;
  view: string;
  useParentForAirportName: boolean;
  flights: FlightsLink[];
}
export const FlightCards = (props: FlightCardsProps) => {
  const { view, isMobile, isTablet, useParentForAirportName, flights } = props;
  const columnNum = isMobile || isTablet ? 1 : 2;
  const keyHelperFlightCard = new ItemKeyHelper("flightCard");
  return (
    <UitkSpacing padding={{ blockstart: "three" }}>
      <UitkLayoutGrid columns={columnNum} space="three">
        <>
          {flights.map((flight, flightIndex) => (
            <UitkLayoutGridItem key={keyHelperFlightCard.next()}>
              <FlightCard
                flight={flight}
                index={flightIndex}
                isMobile={isMobile}
                isTablet={isTablet}
                view={view}
                showCityName={useParentForAirportName}
              />
            </UitkLayoutGridItem>
          ))}
        </>
      </UitkLayoutGrid>
    </UitkSpacing>
  );
};

export default FlightCards;
